import { cva } from 'class-variance-authority';

/**
 * Select トリガーの共通スタイル
 *
 * SelectTrigger と MultipleSelect の両方で使用される
 */
export const selectTriggerStyles = cva(
  [
    'cursor-pointer disabled:cursor-not-allowed',
    'flex w-full items-center justify-between',
    'px-3',
    'text-sm',
    'ring-offset-background',
  ],
  {
    variants: {
      /**
       * 高さの制御
       * - fixed: 固定高さ（単一選択用）
       * - flexible: 最小高さ（複数選択用、タグで高さ可変）
       */
      height: {
        fixed: 'input-field h-8 py-2',
        flexible: 'input-field-without-height min-h-8 py-2',
      },
    },
    defaultVariants: {
      height: 'fixed',
    },
  },
);
